import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import OpportunityCard from './OpportunityCard';

export default function OpportunityColumn({ id, title, opportunities, onOpportunityClick, isReadOnly }) {
  const { setNodeRef } = useDroppable({
    id: id
  });

  const getStatusColor = (status) => {
    switch(status) {
      case 'New': return 'hsl(215, 85%, 60%)'; // blue
      case 'Presented': return 'hsl(270, 85%, 60%)'; // purple
      case 'Approved': return 'hsl(45, 90%, 55%)'; // yellow
      case 'Proposal': return 'hsl(25, 90%, 55%)'; // orange
      case 'Submitted': return 'hsl(150, 85%, 45%)'; // green
      case 'Won': return 'hsl(140, 80%, 40%)'; // dark green
      case 'Lost': return 'hsl(350, 85%, 60%)'; // red
      default: return 'var(--primary)';
    }
  };

  const statusColor = getStatusColor(title);

  const style = {
    minWidth: '280px',
    maxWidth: '280px',
    backgroundColor: 'var(--bg-card)',
    borderRadius: '8px',
    padding: '0.75rem',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    border: '1px solid var(--border-color)'
  };

  return (
    <div ref={setNodeRef} style={style}>
      <h3 style={{ 
        padding: '0.5rem', 
        marginBottom: '1rem', 
        fontSize: '1rem', 
        borderBottom: `2px solid ${statusColor}`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: 'var(--bg-input)',
        borderRadius: '6px 6px 0 0',
        margin: '-0.75rem -0.75rem 1rem -0.75rem',
        paddingLeft: '0.75rem',
        paddingRight: '0.75rem',
        height: '45px'
      }}>
        <div style={{ fontWeight: 600, color: 'var(--text-primary)' }}>
          {title}
        </div>
        <span style={{ 
          fontSize: '0.75rem', 
          backgroundColor: 'var(--bg-card-hover)', 
          border: '1px solid var(--border-color)',
          padding: '0.1rem 0.5rem', 
          borderRadius: '999px',
          color: 'var(--text-secondary)',
          fontWeight: 600
        }}>
          {opportunities.length}
        </span>
      </h3>
      
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {opportunities.map(opportunity => (
          <OpportunityCard 
            key={opportunity.id} 
            opportunity={opportunity} 
            onClick={onOpportunityClick} 
            isReadOnly={isReadOnly} 
          />
        ))}
        {opportunities.length === 0 && (
          <div style={{ textAlign: 'center', padding: '3rem 1rem', color: 'var(--text-secondary)', fontSize: '0.875rem', border: '2px dashed var(--border-color)', borderRadius: '6px', opacity: 0.5 }}>
            Drop opportunities here
          </div>
        )}
      </div>
    </div>
  );
}
